<template>
  <el-row class="table-responsive-lg ">
    <!-- <p class="d-flex justify-content-end" v-if="time_comment"> Cập nhật lúc {{time_comment}}</p> -->
    <div class="mb-4">
      <p class="bold">Hướng dẫn</p>
      <el-row>
        <table class="table table-bordered table-intro m-0">
          <thead>
            <tr>
              <th>Phân loại</th>
              <th>Nội dung</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list_instruct" :key="index">
              <td>{{item.classify}}</td>
              <td>{{item.content}}</td>
            </tr>
          </tbody>
        </table>
      </el-row>
    </div>
      <p class="d-flex justify-content-end" v-if="time_comment"> Cập nhật lúc {{time_comment}}</p>
      <el-row class="table-responsive-lg">
      <p class="bold">Nhận xét học viên</p>
      <div class="table-wrapper-scroll-y">
        <table class="table table-bordered table-striped mb-0">
          <thead>
          <tr>
            <th> Họ và tên</th>
            <th> Mã học viên</th>
            <th class="text-center"> Nhận xét học viên</th>
          </tr>
          </thead>
          <tbody>
          <CommentItem
              v-for="(comment, index) in  comments" :key="index"
              :comment="comment"
              :time_comment="time_comment"
              :optionClassify="option_classify"
              @changeComment="changeComment"
              @changeClassify="changeClassify"
          ></CommentItem>
          </tbody>
        </table>
      </div>
    </el-row>
    <div class="text-red">
      {{checkError}}
    </div>
      <span class="dialog-footer mt-5 d-flex align-items-center justify-content-end">                    
            <el-button style="color: #020202; background-color: #E6E6E6;"
            @click="close">Đóng</el-button>
            <el-button style="color: #fff; background-color: #500DA7;"
            @click="postCommentPhuDao" v-if="type_comment">Gửi nhận xét phụ đạo</el-button>
            <el-button style="color: #fff; background-color: #500DA7;"
            @click="postComment" v-else-if="comments.length && !comments[0].user_comment_time">Gửi nhận xét</el-button>
        </span>
  </el-row>
</template>

<script>

import lodash from 'lodash-es';
import deepdash from 'deepdash-es';
import CommentItem from "./CommentItem";
import {LIST_INSTRUCT, OPTION_CLASSIFY} from "@/core/services/store/course/classes.module";

const _ = deepdash(lodash);

export default {
  components: {CommentItem},
  data() {
    return {
      list_instruct: LIST_INSTRUCT,
      option_classify: OPTION_CLASSIFY,
    }
  },
  props: {
    comments: {
      type: Array,
      default: () => {
        return [];
      }
    },
    type_comment: {
      type: String,
      default: () => {
        return ''
      }
    },
    time_comment: {
      type: String,
      default: () => {
        return ''
      }
    },
    checkError: {
      type: String,
      default: () => {
        return ''
      }
    },
  },
  methods: {
    postComment() {
      this.$emit('postComment');
    },
    postCommentPhuDao() {
      this.$emit('postCommentPhuDao');
    },
    changeComment(item, value) {
      this.$emit('changeComment', item, value);
    },
    close: function () {
      this.$emit('close');
    },
    changeClassify(item, value) {
      this.$emit('changeClassify',item , value);
    }
  },
}
</script>
<style>
.text-red {
  color: red;
}

.table-wrapper-scroll-y {
  table-layout: fixed;
  border-collapse: collapse;
}
@media (max-width: 426px) {
  .table-wrapper-scroll-y tbody {
    width: 400px;  
  }
}
.table-wrapper-scroll-y tbody {
  display: block;
  overflow: auto;
  height: 400px;
}
.table-wrapper-scroll-y thead tr {
  display: block;
}
.table-wrapper-scroll-y th,
table-wrapper-scroll-y thead,
.table-wrapper-scroll-y td {
  text-align: left;
  width: 400px;
}
.table-intro th,
td {
  word-break: initial;
}
</style>
